import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from '@/api/setup/baseQuery'
import { adminServiceAiBaseUrl } from './utils'

export const aiAdminApiSlice = createApi({
  reducerPath: 'aiAdminApi',
  baseQuery: baseQueryWithReauth({ baseUrl: adminServiceAiBaseUrl }),
  endpoints: (builder) => ({
    getAiInsights: builder.query({
      query: (buildingId) => ({
        url: `api/v2/buildings/${buildingId}/ai/insights`,
        method: 'GET',
      }),
      keepUnusedDataFor: 30,
    }),
    getAiStatus: builder.query({
      query: (buildingId) => ({
        url: `api/v2/buildings/${buildingId}/ai/status`,
        method: 'GET',
      }),
      keepUnusedDataFor: 60,
    }),
  }),
})

export const { useGetAiInsightsQuery, useLazyGetAiInsightsQuery, useGetAiStatusQuery } =
  aiAdminApiSlice
